<template>
  <v-dialog :value="isShow" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Cập nhật người phụ trách
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển sale gia hạn"
              >
                <common-select-user
                  v-model="sale"
                  :items="listUser"
                  color="primary"
                  item-text="fullName"
                  :item-value="(item) => item"
                  :error-messages="errors"
                  placeholder="Tìm kiếm người phụ trách theo tên"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu Lại</v-btn>
          <v-spacer />
          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import * as moment from 'moment';
import { mapActions } from 'vuex';

export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
    studentsDuo: {
      type: Array,
      default: () => [],
    },
    listUser: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      sale: {},
    };
  },
  created() {},
  methods: {
    ...mapActions('student_care', ['apiUpdate']),
    hideModal() {
      this.$emit('close-modal-change-homeroom-teacher', false);
      this.errorMessage = '';
    },
    async saveChange() {
      if (this.studentsDuo && this.studentsDuo.length > 0) {
        const listSelectedId = [];
        this.studentsDuo.forEach(
          (contact) => {
            if (contact.checkbox) {
              listSelectedId.push(contact.id);
            }
          },
        );

        if (listSelectedId.length === 0) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn khách hàng !!!',
          });
        }

        if (!this.sale.id || !this.sale.fullName) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn Nguời phụ trách !!!',
          });
        }
        this.appLoadingData(true);
        const result = await this.apiUpdate({
          obj: 'routine',
          data: {
            user_id: this.sale.id,
            user_name: this.sale.fullName,
          },
          filters: {
            $in__id: listSelectedId,
          },
        });
        this.appLoadingData(false);
        if (result && result.message === 'Success') {
          this.hideModal();
          this.filterForm.checkboxAll = false;
          this.$swal({
            type: 'success',
            title: 'Thành công',
            text: 'Chuyển Người phụ trách thành công!!!',
          }).then(() => {
            Bus.$emit('duo-care-list-filter');
          });
        } else {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: `Có lỗi khi cập nhật người phụ trách: ${result.message} !!!`,
          });
        }
      }
      return true;
    },
    formatDateCustom(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    duoChangeUser() {

    },
  },
};
</script>
